"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("../../utils/styled-components"));
var Photo16 = function (props) { return (react_1.default.createElement("svg", __assign({ viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
    react_1.default.createElement("defs", null,
        react_1.default.createElement("path", { d: "M17.391 0c1.639 0 2.366.256 3.017 1.453l.426.848c.442.85.708 1.157.993 1.205l.086.008h2.26c2.15 0 3.676 1.475 3.816 3.603l.011.324V19.74c0 2.191-1.424 3.771-3.509 3.917l-.317.01H3.826c-2.148 0-3.675-1.475-3.815-3.603L0 19.739V7.44C0 5.25 1.424 3.67 3.509 3.524l.317-.01h2.261c.349 0 .642-.332 1.212-1.475l.148-.302C8.1.384 8.764.04 10.292.004l7.1-.004zm.246 2h-7.274c-.661.003-.806.033-.975.33l-.14.276C8.287 4.598 7.674 5.41 6.36 5.504l-.272.01h-2.26c-1.055 0-1.726.617-1.817 1.675L2 7.441V19.74c0 1.125.596 1.823 1.59 1.917l.236.01h20.348c1.054 0 1.725-.616 1.816-1.675l.01-.252V7.44c0-1.125-.596-1.823-1.59-1.917l-.236-.01h-2.261c-1.412 0-2.054-.688-2.968-2.515l-.322-.649c-.174-.316-.31-.347-.986-.35zM14 5.833a7.001 7.001 0 11-.002 14.002A7.001 7.001 0 0114 5.833zm0 2a5 5 0 100 10 5 5 0 000-10zm0 1a4 4 0 11-.001 8.001 4 4 0 01.001-8zm0 2a2 2 0 100 4 2 2 0 000-4zm8-4a1 1 0 110 2 1 1 0 010-2z", id: "photo-16_svg__a" })),
    react_1.default.createElement("g", { transform: "translate(2 4)", fill: "currentColor", fillRule: "evenodd" },
        react_1.default.createElement("mask", { id: "photo-16_svg__b" },
            react_1.default.createElement("use", { xlinkHref: "#photo-16_svg__a" })),
        react_1.default.createElement("use", { xlinkHref: "#photo-16_svg__a" }),
        react_1.default.createElement("g", { mask: "url(#photo-16_svg__b)" },
            react_1.default.createElement("path", { d: "M-2-4h64v64H-2z" }))))); };
var StyledPhoto16 = styled_components_1.default(Photo16)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: ", ";\n  height: ", ";\n  color: ", ";\n  vertical-align: middle;\n  fill: ", ";\n\n  ", "\n"], ["\n  width: ", ";\n  height: ", ";\n  color: ", ";\n  vertical-align: middle;\n  fill: ", ";\n\n  ", "\n"])), function (_a) {
    var _b = _a.size, size = _b === void 0 ? '32px' : _b;
    return size;
}, function (_a) {
    var _b = _a.size, size = _b === void 0 ? '32px' : _b;
    return size;
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.base.color.text;
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.base.color.text;
}, function (_a) {
    var stroke = _a.stroke;
    return stroke && "stroke: " + stroke + "; stroke-width: 64;";
});
exports.default = StyledPhoto16;
var templateObject_1;
//# sourceMappingURL=Photo16.js.map